// SEO优化配置 - 宠物相关关键词策略
export interface SEOConfig {
  title: string
  description: string
  keywords: string[]
  ogTitle?: string
  ogDescription?: string
  structuredData?: any
}

// 核心宠物关键词库
export const PET_KEYWORDS = {
  // 猫咪相关
  cat: [
    '猫咪', '猫用品', '猫粮', '猫零食', '猫玩具', '猫砂', '猫爬架', '猫窝', 
    '猫咪健康', '猫咪护理', '猫咪医疗', '猫医生', '猫咪疫苗', '猫咪体检',
    '幼猫', '成猫', '老年猫', '英短', '美短', '布偶猫', '折耳猫', '加菲猫'
  ],
  // 宠物通用
  pet: [
    '宠物', '宠物用品', '宠物食品', '宠物健康', '宠物医院', '宠物护理',
    '宠物社区', '宠物知识', '宠物训练', '宠物美容', '宠物寄养', '宠物保险'
  ],
  // 商业相关
  business: [
    '网购', '在线购物', '宠物商城', '品质保证', '包邮', '优质服务',
    '专业', '可靠', '实惠', '性价比', '正品', '全国配送'
  ],
  // 地域相关
  location: [
    '北京', '上海', '广州', '深圳', '杭州', '成都', '武汉', '西安', '南京', '天津',
    '全国', '中国', '国内', '线上', '网上'
  ]
}

// 页面SEO配置
export const PAGE_SEO_CONFIG: Record<string, SEOConfig> = {
  home: {
    title: '猫星球 - 专业猫咪用品商城 | 优质猫粮猫玩具猫砂一站式购物平台',
    description: '猫星球是国内领先的猫咪用品购物平台，提供优质猫粮、猫零食、猫玩具、猫砂、猫爬架等全品类猫咪用品。专业猫医生在线咨询，猫友社区分享养猫经验。品质保证，全国包邮。',
    keywords: [
      '猫咪用品', '猫粮', '猫零食', '猫玩具', '猫砂', '猫爬架', '猫窝',
      '宠物用品', '猫咪健康', '猫医生', '养猫知识', '猫友社区',
      '网购猫用品', '猫咪商城', '优质猫粮', '专业宠物用品'
    ],
    ogTitle: '猫星球 - 让每只猫咪都能享受优质生活',
    ogDescription: '专业的猫咪用品购物平台，汇聚全球优质品牌，AI猫医生24小时在线，猫友社区互助分享，为您的爱猫提供最好的呵护。',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "猫星球",
      "url": "https://catparty.vip",
      "description": "专业猫咪用品商城，提供猫粮、猫玩具、猫医疗服务",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://catparty.vip/store?search={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    }
  },
  store: {
    title: '猫咪用品商城 - 优质猫粮猫玩具猫砂在线选购 | 猫星球',
    description: '猫星球商城汇聚全球优质猫咪用品品牌，包括进口猫粮、天然猫零食、益智猫玩具、除臭猫砂、豪华猫爬架等。正品保证，专业推荐，让您的爱猫享受品质生活。',
    keywords: [
      '猫咪用品商城', '买猫粮', '猫玩具购买', '猫砂选择', '猫爬架推荐',
      '进口猫粮', '天然猫零食', '猫咪日用品', '宠物用品网购',
      '优质猫用品', '猫咪护理用品', '幼猫用品', '成猫食品'
    ],
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Store",
      "name": "猫星球商城",
      "description": "专业猫咪用品购物平台"
    }
  },
  'ai-doctor': {
    title: 'AI猫医生在线咨询 - 24小时猫咪健康问诊服务 | 猫星球',
    description: '猫星球AI猫医生提供24小时在线猫咪健康咨询服务。专业解答猫咪疾病、营养、行为等问题，科学养猫指导，让您的爱猫健康成长。免费咨询，专业可靠。',
    keywords: [
      'AI猫医生', '猫咪健康咨询', '在线兽医', '猫咪疾病诊断', '养猫知识',
      '猫咪营养咨询', '猫咪行为分析', '宠物医疗服务', '猫咪护理指导',
      '免费咨询', '专业猫医生', '猫咪体检', '幼猫护理', '老年猫照顾'
    ],
    structuredData: {
      "@context": "https://schema.org",
      "@type": "MedicalOrganization",
      "name": "猫星球AI医疗中心",
      "description": "提供专业的猫咪健康咨询服务",
      "availableService": {
        "@type": "MedicalService",
        "name": "猫咪健康咨询",
        "description": "24小时在线AI猫医生咨询服务"
      }
    }
  },
  community: {
    title: '猫友社区 - 分享养猫经验交流猫咪生活 | 猫星球',
    description: '猫星球社区是国内活跃的猫友交流平台，分享养猫经验、猫咪日常、萌宠照片。讨论猫咪健康、训练技巧、用品推荐。加入万千猫友，一起科学养猫，快乐撸猫。',
    keywords: [
      '猫友社区', '养猫经验分享', '猫咪交流', '撸猫日常', '萌宠照片',
      '猫咪训练', '养猫知识', '猫友互助', '宠物社区', '猫咪行为',
      '养猫技巧', '猫咪故事', '铲屎官', '猫奴交流', '科学养猫'
    ],
    structuredData: {
      "@context": "https://catparty.vip",
      "@type": "SocialMediaPosting",
      "name": "猫友社区",
      "description": "猫友交流分享平台"
    }
  }
}

// 生成动态关键词
export function generateDynamicKeywords(baseKeywords: string[], context: string): string[] {
  const locationKeywords = PET_KEYWORDS.location.slice(0, 3)
  const businessKeywords = PET_KEYWORDS.business.slice(0, 3)
  
  return [
    ...baseKeywords,
    ...locationKeywords.map(loc => `${loc}${context}`),
    ...businessKeywords.map(biz => `${biz}${context}`)
  ]
}

// 获取页面SEO配置
export function getPageSEO(route: string): SEOConfig {
  const routeName = route.replace('/', '') || 'home'
  return PAGE_SEO_CONFIG[routeName] || PAGE_SEO_CONFIG.home
}
